<template>
  <div style="width: 100% ; height: 100vh ; background-color: #28243d !important; ; position: fixed ; overflow: auto ">
    <div class="auth-wrapper auth-v2">
      <v-dialog
        v-model="alert"
        persistent
        max-width="450"
      >
        <v-container>
          <v-row>
            <v-col>
              <v-alert
                color="error"
                dense
                dismissible
                elevation="4"
                prominent
                shaped
                type="error"
                v-model="alert"
              >لطفا تمام فیلدها را صحیح وارد نمایید</v-alert>
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <div class="auth-inner">
        <v-row class="auth-row ma-0">
          <v-col
            lg="4"
            class="d-none d-lg-block position-relative overflow-hidden pa-0"
          >
            <div class="auth-illustrator-wrapper">
              <!-- 3d character -->
              <div class="d-flex align-center h-full pa-16 pe-0">
                <v-img
                  contain
                  width="100%"
                  :src="require(`@/assets/images/nitron.jpg`)"
                ></v-img>
              </div>
            </div>
          </v-col>

          <v-col
            lg="8"
            class="d-flex align-center  pa-10 pb-0"
          >
            <v-row>
              <v-col
                cols="12"
                class="mx-auto"
              >
                <v-card flat>
                  <!-- login form -->
                  <v-card-text>
                    <v-container fluid>
                      <v-row>
                        <v-col cols="12" lg="4" xl="4" md="12" sm="12">
                          <!-- brand logo -->
                          <v-img
                            :src="appLogo"
                            max-height="77px"
                            max-width="150px"
                            alt="logo"
                            class="me-3 ma-auto"
                          ></v-img>
                          <!--/ brand logo -->
                        </v-col>
                        <v-col cols="12" lg="8" xl="8" md="12" sm="12">
                          <v-alert
                            text
                            width="100%"
                            color="primary"
                          >
                            <small class="d-block mb-1">
                              توجه داشته باشید ابتدا حساب باید توسط مدیر اصلی تایید شود
                            </small>
                            <small class="d-block mb-1">
                              در صورت وجود مشکل به شماره زیر تماس بگیرید
                            </small>
                            <small>
                              تلفن: <strong>01334935</strong>
                            </small>
                          </v-alert>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-form
                      ref="registerForm"
                      v-model="registerValidation"
                      @submit.prevent="register"
                    >
                      <v-row class="pt-0 pb-0">
                        <v-col class="pt-0 pb-0" cols="12" sm="12" md="12" lg="4" xl="4">
                          <v-text-field
                            v-model="first_name"
                            dense
                            outlined
                            label="نام"
                            placeholder="نام"
                            hide-details="auto"
                            :rules="[v => !!v || 'این فیلد اجباری است']"
                            class="mb-6"
                          ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="12" sm="12" md="12" lg="4" xl="4">
                          <v-text-field
                            v-model="last_name"
                            dense
                            outlined
                            label="نام خانوادگی"
                            placeholder="نام خانوادگی"
                            hide-details="auto"
                            :rules="[v => !!v || 'این فیلد اجباری است']"
                            class="mb-6"
                          ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="12" sm="12" md="12" lg="4" xl="4">
                          <v-text-field
                            v-model="phoneEmail"
                            dense
                            outlined
                            v-mask="'09## ### ####'"
                            label="شماره تلفن همراه"
                            placeholder="شماره تلفن همراه"
                            hide-details="auto"
                            :rules="[v => !!v || 'این فیلد اجباری است']"
                            class="mb-6 phoneThings"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="pt-0 pb-0">
                        <v-col class="pt-0 pb-0" cols="12" sm="12" md="12" lg="6" xl="6">
                          <v-text-field
                            v-model="agent_code"
                            dense
                            outlined
                            label="کد دفتر (فقط عدد وارد کنید)"
                            class="mb-2"
                            type="number"
                            :rules="[v => !!v || 'این فیلد اجباری است']"
                          ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="12" sm="12" md="12" lg="6" xl="6">
                          <v-text-field
                            v-model="organ_name"
                            dense
                            outlined
                            label="نام"
                            placeholder="دفتر پیشخوان نمونه ..."
                            persistent-placeholder
                            class="mb-2"
                            :rules="[v => !!v || 'این فیلد اجباری است']"
                          ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="12" sm="12" md="12" lg="6" xl="6">
                          <v-text-field
                            v-model="password"
                            dense
                            outlined
                            :type="isPasswordVisible ? 'text' : 'password'"
                            label="رمز عبور"
                            placeholder="رمز عبور"
                            :rules="[v => !!v || 'این فیلد اجباری است', v => (v && v.length >= 8) || 'لطفا بیشتر از 8 حرف وارد نمایید']"
                            :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
                            hide-details="auto"
                            class="mb-2"
                            @click:append="isPasswordVisible = !isPasswordVisible"
                          ></v-text-field>
                        </v-col>
                        <v-col class="pt-0 pb-0" cols="12" sm="12" md="12" lg="6" xl="6">
                          <v-text-field
                            v-model="password_confirmation"
                            dense
                            outlined
                            :type="isPasswordConfirmationVisible ? 'text' : 'password'"
                            label="تکرار رمز عبور"
                            placeholder="تکرار رمز عبور"
                            :append-icon="isPasswordConfirmationVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
                            hide-details="auto"
                            class="mb-2"
                            :rules="[v => !!v || 'این فیلد اجباری است', v => (v && v === password) || 'تکرار باید یکسان باشد']"
                            @click:append="isPasswordConfirmationVisible = !isPasswordConfirmationVisible"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="pt-0 pb-0">
                        <v-col class="pt-0 pb-0">
                          <v-btn
                            block
                            dense
                            color="primary"
                            type="submit"
                            class="mt-6"
                          >
                            ثبت نام
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>

                  <!-- create new account  -->
                  <v-card-text class="d-flex align-center justify-center flex-wrap mt-2">
                    <router-link to="login">
                      ورود به حساب کاربر
                    </router-link>
                  </v-card-text>

                  <!-- divider -->
                  <v-card-text class="d-flex align-center mt-2">
                    <v-divider></v-divider>
                    <span class="mx-5">راه های ارتباطی</span>
                    <v-divider></v-divider>
                  </v-card-text>

                  <!-- socail links -->
                  <v-card-actions class="d-flex justify-center">
                    <v-tooltip bottom v-for="link in socialLink" :key="link.icon">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          class="ms-1"
                          :href="link.link"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon :color="$vuetify.theme.dark ? link.colorInDark:link.color">
                            {{ link.icon }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ link.tooltip }}</span>
                    </v-tooltip>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiEyeOutline,
  mdiEyeOffOutline, mdiTelegram
} from '@mdi/js'
import axios from '@axios'
import themeConfig from '@themeConfig'
import baseConfig from '@/../baseConfig'
import router from "@/router";
import {removeCharFromString} from "@/views/generator/page-handler";
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },
  data() {
    return {
      registerValidation : false,
      phoneEmail: "",
      first_name: "",
      last_name: "",
      password: "",
      password_confirmation: "",
      agent_code: "",
      organ_name: "",
      isPasswordVisible: false,
      isPasswordConfirmationVisible: false,
      alert: false,
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,
      socialLink: [
        {
          icon: mdiTelegram,
          color: '#4267b2',
          colorInDark: '#4267b2',
          link: 'tg://resolve?domain=mevarizi',
          tooltip: 'کانال اطلاع رسانی',
        },
        {
          icon: mdiTelegram,
          color: '#b424d4',
          colorInDark: '#ba0c9d',
          link: 'tg://resolve?domain=adham54470',
          tooltip: 'ارتباط با مدیریت',
        },
        {
          icon: mdiTelegram,
          color: '#24d42d',
          colorInDark: '#078a23',
          link: 'tg://resolve?domain=Ssupportvarizi',
          tooltip: 'واحد پشتیبانی',
        },
      ]
    }
  },
  methods: {
    register() {
      try {
        if (this.registerValidation) {
          axios.post(baseConfig.baseUrl +'custom/register', {
            first_name: this.first_name,
            last_name: this.last_name,
            phoneEmail: removeCharFromString(this.phoneEmail, ' '),
            password: this.password,
            password_confirmation: this.password_confirmation,
            agent_code: this.agent_code,
            organ_name: this.organ_name,
          })
            .then(response => {
              //was const {token} = response.data.data
              //was console.log(token)
              // ? Set access token in localStorage so axios interceptor can use it
              // Axios Interceptors: https://github.com/axios/axios#interceptors
              //was localStorage.setItem('accessToken', token)
              //was router.push('/')
              if(response.data.status==='success'){
                alert(response.data.message)
              }else{
                alert(response.data.message)
              }
            })
            .then(() => {

            })
        } else {
          this.$refs.registerForm.validate()
          this.alert = true
        }
      }
      catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@core/preset/preset/pages/auth.scss';
div.d-flex:nth-child(1){
  background-color: #28243d;
}
html{
  min-height: 100%;
  position: fixed;
  min-width: 100%;
  background-color: #28243d !important;
}
</style>
<style>
.phoneThings input{
  direction: ltr !important;
}
</style>
